import React from 'react';
import { IntlProvider } from 'react-intl';
const I18nProvider = ({ locale, messages, children }) => {
    return (React.createElement(IntlProvider, { locale: locale, messages: messages }, children));
};
export { I18nProvider };
